export default class TopicAdapter {
  static global() {
    if (typeof window.Topic === 'undefined') {
      return this.nullObject();
    }
    return window.Topic;
  }

  static nullObject() {
    return {
      publish: this.noop,
      subscribe: this.stubSubscribe
    };
  }

  static noop() {}
  static stubSubscribe() {
    return {
      remove: this.noop
    }
  }

  static publish() {
    this.global().publish(...arguments);
  }

  static subscribe() {
    return this.global().subscribe(...arguments);
  }
}
